import React, { useState, useEffect } from "react";
import { Map, Marker, InfoWindow } from "@vis.gl/react-google-maps";
import { APIProvider } from "@vis.gl/react-google-maps";

const MapView = ({ selectedLocation, locations }) => {
    const googleMapsApiKey = process.env.REACT_APP_GOOGLE_MAP_KEY;
    const [selectedMarker, setSelectedMarker] = useState(null);
    const [mapCenter, setMapCenter] = useState(selectedLocation);
    const [reloadCount, setReloadCount] = useState(0);

    useEffect(() => {
        if (locations?.length > 0) {
            const firstVendorLocation = locations[0]?.locations?.[0];
            if (firstVendorLocation) {
                setMapCenter({
                    lat: firstVendorLocation.latitude,
                    lng: firstVendorLocation.longitude,
                });
            }
        }
        setReloadCount((prev) => prev + 1);
    }, [locations]);

    return (
        <APIProvider apiKey={googleMapsApiKey} key={reloadCount}>
            <div className="relative">
                <Map
                    style={{ borderRadius: "20px", height: "75vh", width: "100%" }}
                    defaultZoom={5}
                    center={mapCenter}
                    gestureHandling="greedy"
                    disableDefaultUI
                >
                    {Array.isArray(locations) ? (
                        locations.map((vendor, vendorIndex) => (
                            Array.isArray(vendor.locations) ? (
                                vendor.locations.map((location, locationIndex) => (
                                    <Marker
                                        key={`${vendorIndex}-${locationIndex}`}
                                        position={{
                                            lat: location.latitude,
                                            lng: location.longitude,
                                        }}
                                        onClick={() => setSelectedMarker(`${vendorIndex}-${locationIndex}`)}
                                    >
                                        {selectedMarker === `${vendorIndex}-${locationIndex}` && (
                                            <InfoWindow
                                                position={{
                                                    lat: location.latitude,
                                                    lng: location.longitude,
                                                }}
                                                onCloseClick={() => setSelectedMarker(null)}
                                            >
                                                <div>
                                                    <h2 className="font-bold text-lg">{vendor.business_name}</h2>
                                                    <p>
                                                        {vendor.first_name} {vendor.last_name}
                                                    </p>
                                                </div>
                                            </InfoWindow>
                                        )}
                                    </Marker>
                                ))
                            ) : null
                        ))
                    ) : (
                        Array.isArray(locations.locations) ? (
                            locations.locations.map((location, locationIndex) => (
                                <Marker
                                    key={`single-${locationIndex}`}
                                    position={{
                                        lat: location.latitude,
                                        lng: location.longitude,
                                    }}
                                    onClick={() => setSelectedMarker(`single-${locationIndex}`)}
                                >
                                    {selectedMarker === `single-${locationIndex}` && (
                                        <InfoWindow
                                            position={{
                                                lat: location.latitude,
                                                lng: location.longitude,
                                            }}
                                            onCloseClick={() => setSelectedMarker(null)}
                                        >
                                            <div>
                                                <h2 className="font-bold text-lg">{locations.business_name || "Unknown"}</h2>
                                                <p>
                                                    {locations.first_name || ""} {locations.last_name || ""}
                                                </p>
                                            </div>
                                        </InfoWindow>
                                    )}
                                </Marker>
                            ))
                        ) : null
                    )}

                </Map>
            </div>
        </APIProvider>
    );
};

export default MapView;
